import { faImage } from "@fortawesome/free-solid-svg-icons";

export const filesIcon = faImage;
